import { Link, useNavigate } from "react-router-dom";
import React from "react";
import { Dropdown } from "react-bootstrap";
import UserAvatar from "../components/UserAvatar";
import SimpleBar from "simplebar-react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../store/store";
import authSlice from "../../store/slices/auth.slice";
import { useTranslation } from "react-i18next";
import { handleLanguageChange } from "../../utils/localization/i18n";

interface HeaderProps {
  themeMode?: string;
  changeThemeMode?: any;
  toogleMobileSidebarHide?: () => void;
  handleOffcanvasToggle?: () => void;
  hasSidebar?: boolean;
}

const Header = ({
  handleOffcanvasToggle,
  changeThemeMode,
  toogleMobileSidebarHide,
  hasSidebar,
}: HeaderProps) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { userData } = useSelector((state: RootState) => state.auth);

  const handleLogout = () => {
    localStorage.removeItem("token");
    dispatch(authSlice.actions.setLogoutState());
    navigate("/");
  };

  const toogleSidebarHide = () => {
    const sidebarHideId = document.getElementById("pc-sidebar-hide");

    if (sidebarHideId) {
      sidebarHideId.classList.toggle("pc-sidebar-hide");
    }
  };

  return (
    <>
      <header className="pc-header">
        <div className="header-wrapper">
          <div className="me-auto pc-mob-drp">
            <ul className="list-unstyled">
              {!hasSidebar && (
                <li className="pc-h-item pc-sidebar-collapse">
                  <Link to="/" className="b-brand text-primary d-flex align-items-center gap-3 p-2">
                    <img
                      src={"/assets/images/logo-horizontal.png"}
                      alt="logo"
                      className="logo-lg"
                      style={{ height: "45px", width: "auto" }}
                    />
                  </Link>
                </li>
              )}

              {hasSidebar && (
                <li className="pc-h-item pc-sidebar-collapse">
                  <Link
                    to="#"
                    className="pc-head-link ms-0"
                    id="sidebar-hide"
                    onClick={toogleSidebarHide}
                  >
                    <i className="ph-duotone ph-list"></i>
                  </Link>
                </li>
              )}
              {hasSidebar && (
                <li className="pc-h-item pc-sidebar-popup">
                  <Link
                    to="#"
                    className="pc-head-link ms-0"
                    id="mobile-collapse"
                    onClick={toogleMobileSidebarHide}
                  >
                    <i className="ph-duotone ph-list"></i>
                  </Link>
                </li>
              )}

              <Dropdown as="li" className="pc-h-item d-inline-flex d-md-none">
                <Dropdown.Toggle
                  as="a"
                  className="pc-head-link arrow-none m-0"
                  href="#"
                  role="button"
                  aria-haspopup="false"
                  aria-expanded="false"
                >
                  <i className="ph-duotone ph-magnifying-glass"></i>
                </Dropdown.Toggle>
                <Dropdown.Menu className="pc-h-dropdown drp-search">
                  <form className="px-3">
                    <div className="form-group mb-0 d-flex align-items-center">
                      <input
                        type="search"
                        className="form-control border-0 shadow-none"
                        placeholder={t("general.searchPlaceholder")}
                      />
                      <button className="btn btn-light-secondary btn-search">
                        {t("button.search")}
                      </button>
                    </div>
                  </form>
                </Dropdown.Menu>
              </Dropdown>
            </ul>
          </div>

          <div className="ms-auto">
            <ul className="list-unstyled">
              {/* <Dropdown
                as="li"
                className="dropdown pc-h-item d-none d-md-inline-flex"
              >
                <Dropdown.Toggle
                  as="a"
                  className="pc-head-link dropdown-toggle arrow-none me-0"
                  href="#"
                  role="button"
                  aria-haspopup="false"
                  aria-expanded="false"
                >
                  <i className="ph-duotone ph-circles-four"></i>
                </Dropdown.Toggle>
                <Dropdown.Menu className="dropdown-menu dropdown-qta dropdown-menu-end pc-h-dropdown">
                  <div className="overflow-hidden">
                    <div className="qta-links m-n1">
                      <Dropdown.Item href="#!" className="dropdown-item">
                        <i className="ph-duotone ph-shopping-cart"></i>
                        <span>E-commerce</span>
                      </Dropdown.Item>
                      <Dropdown.Item href="#!" className="dropdown-item">
                        <i className="ph-duotone ph-lifebuoy"></i>
                        <span>Helpdesk</span>
                      </Dropdown.Item>
                      <Dropdown.Item href="#!" className="dropdown-item">
                        <i className="ph-duotone ph-scroll"></i>
                        <span>Invoice</span>
                      </Dropdown.Item>
                      <Dropdown.Item href="#!" className="dropdown-item">
                        <i className="ph-duotone ph-books"></i>
                        <span>Online Courses</span>
                      </Dropdown.Item>
                      <Dropdown.Item href="#!" className="dropdown-item">
                        <i className="ph-duotone ph-envelope-open"></i>
                        <span>Mail</span>
                      </Dropdown.Item>
                      <Dropdown.Item href="#!" className="dropdown-item">
                        <i className="ph-duotone ph-identification-badge"></i>
                        <span>Membership</span>
                      </Dropdown.Item>
                      <Dropdown.Item href="#!" className="dropdown-item">
                        <i className="ph-duotone ph-chats-circle"></i>
                        <span>Chat</span>
                      </Dropdown.Item>
                      <Dropdown.Item href="#!" className="dropdown-item">
                        <i className="ph-duotone ph-currency-circle-dollar"></i>
                        <span>Plans</span>
                      </Dropdown.Item>
                      <Dropdown.Item href="#!" className="dropdown-item">
                        <i className="ph-duotone ph-user-circle"></i>
                        <span>Users</span>
                      </Dropdown.Item>
                    </div>
                  </div>
                </Dropdown.Menu>
              </Dropdown> */}
              {/* <Dropdown as="li" className="pc-h-item d-none d-md-inline-flex">
                <Dropdown.Toggle
                  as="a"
                  className="pc-head-link arrow-none me-0"
                  href="#"
                  role="button"
                  aria-haspopup="false"
                  aria-expanded="false"
                >
                  <i className="ph-duotone ph-sun-dim"></i>
                </Dropdown.Toggle> */}
              {/*<Dropdown.Menu className="dropdown-menu-end pc-h-dropdown">*/}
              {/*  <Dropdown.Item*/}
              {/*    onClick={() => handleThemeChange(THEME_MODE.DARK)}*/}
              {/*  >*/}
              {/*    <i className="ph-duotone ph-moon"></i>*/}
              {/*    <span>Dark</span>*/}
              {/*  </Dropdown.Item>*/}
              {/*  <Dropdown.Item*/}
              {/*    onClick={() => handleThemeChange(THEME_MODE.LIGHT)}*/}
              {/*  >*/}
              {/*    <i className="ph-duotone ph-sun-dim"></i>*/}
              {/*    <span>Light</span>*/}
              {/*  </Dropdown.Item>*/}
              {/*  <Dropdown.Item*/}
              {/*    onClick={() => handleThemeChange(THEME_MODE.DEFAULT)}*/}
              {/*  >*/}
              {/*    <i className="ph-duotone ph-cpu"></i>*/}
              {/*    <span>Default</span>*/}
              {/*  </Dropdown.Item>*/}
              {/*</Dropdown.Menu>*/}
              {/* </Dropdown> */}

              <Dropdown as="li" className="pc-h-item d-none d-md-inline-flex">
                <Dropdown.Toggle
                  as="a"
                  className="pc-head-link head-link-primary dropdown-toggle arrow-none me-0"
                  href="#"
                  role="button"
                  aria-haspopup="false"
                  aria-expanded="false"
                >
                  <i className="ph-duotone ph-translate"></i>
                </Dropdown.Toggle>
                <Dropdown.Menu className="dropdown-menu-end pc-h-dropdown lng-dropdown">
                  {[
                    { code: "en", name: t("language.english"), description: t("language.uk") },
                    { code: "de", name: t("language.german"), description: t("language.germany") },
                  ].map((lang) => (
                    <Dropdown.Item
                      key={lang.code}
                      href="#!"
                      onClick={() => handleLanguageChange(lang.code)}
                    >
                      <span>
                        {lang.name} <small>({lang.description})</small>
                      </span>
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
              </Dropdown>

              {/* <li className="pc-h-item">
                <a
                  className="pc-head-link pct-c-btn"
                  onClick={handleOffcanvasToggle}
                  href="#"
                  data-bs-toggle="offcanvas"
                  data-bs-target="#offcanvas_pc_layout"
                >
                  <i className="ph-duotone ph-gear-six"></i>
                </a>
              </li> */}
              {/* <Dropdown as="li" className="pc-h-item">
                <Dropdown.Toggle
                  as="a"
                  className="pc-head-link arrow-none me-0"
                  href="#"
                  role="button"
                  aria-haspopup="false"
                  aria-expanded="false"
                >
                  <i className="ph-duotone ph-diamonds-four"></i>
                </Dropdown.Toggle>
                <Dropdown.Menu className="dropdown-menu-end pc-h-dropdown">
                  <Dropdown.Item>
                    <i className="ph-duotone ph-user"></i>
                    <span>My Account</span>
                  </Dropdown.Item>
                  <Dropdown.Item>
                    <i className="ph-duotone ph-gear"></i>
                    <span>Settings</span>
                  </Dropdown.Item>
                  <Dropdown.Item>
                    <i className="ph-duotone ph-lifebuoy"></i>
                    <span>Support</span>
                  </Dropdown.Item>
                  <Dropdown.Item>
                    <i className="ph-duotone ph-lock-key"></i>
                    <span>Lock Screen</span>
                  </Dropdown.Item>
                  <Dropdown.Item>
                    <i className="ph-duotone ph-power"></i>
                    <span>Logout</span>
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown> */}
              {/* <Dropdown as="li" className="pc-h-item">
                <Dropdown.Toggle
                  as="a"
                  className="pc-head-link arrow-none me-0"
                  href="#"
                  aria-haspopup="false"
                >
                  <i className="ph-duotone ph-bell"></i>
                  <span className="badge bg-success pc-h-badge">3</span>
                </Dropdown.Toggle>
                <Dropdown.Menu className="dropdown-notification dropdown-menu-end pc-h-dropdown">
                  <div className="dropdown-header d-flex align-items-center justify-content-between">
                    <h4 className="m-0">Notifications</h4>
                    <ul className="list-inline ms-auto mb-0">
                      <li className="list-inline-item">
                        <Link
                          to="/application/mail"
                          className="avtar avtar-s btn-link-hover-primary"
                        >
                          <i className="ph-duotone ph-link f-18"></i>
                        </Link>
                      </li>
                    </ul>
                  </div>
                  <SimpleBar
                    className="dropdown-body text-wrap header-notification-scroll position-relative h-100"
                    style={{ maxHeight: "calc(100vh - 235px)" }}
                  >
                    <ul className="list-group list-group-flush">
                      <li className="list-group-item">
                        <p className="text-span">Today</p>
                        <div className="d-flex">
                          <div className="flex-shrink-0">
                            <img
                              src={"/assets/images/user/avatar-1.jpg"}
                              alt="user-image"
                              className="user-avtar avtar avtar-s"
                            />
                          </div>
                          <div className="flex-grow-1 ms-3">
                            <div className="d-flex">
                              <div className="flex-grow-1 me-3 position-relative">
                                <h6 className="mb-0 text-truncate">
                                  Keefe Bond added new tags to 💪 Design system
                                </h6>
                              </div>
                              <div className="flex-shrink-0">
                                <span className="text-sm">2 min ago</span>
                              </div>
                            </div>
                            <p className="position-relative text-muted mt-1 mb-2">
                              <br />
                              <span className="text-truncate">
                                Lorem Ipsum has been the industry&apos;s
                                standard dummy text ever since the 1500s.
                              </span>
                            </p>
                            <span className="badge bg-light-primary border border-primary me-1 mt-1">
                              web design
                            </span>
                            <span className="badge bg-light-warning border border-warning me-1 mt-1">
                              Dashobard
                            </span>
                            <span className="badge bg-light-success border border-success me-1 mt-1">
                              Design System
                            </span>
                          </div>
                        </div>
                      </li>
                      <li className="list-group-item">
                        <div className="d-flex">
                          <div className="flex-shrink-0">
                            <div className="avtar avtar-s bg-light-primary">
                              <i className="ph-duotone ph-chats-teardrop f-18"></i>
                            </div>
                          </div>
                          <div className="flex-grow-1 ms-3">
                            <div className="d-flex">
                              <div className="flex-grow-1 me-3 position-relative">
                                <h6 className="mb-0 text-truncate">Message</h6>
                              </div>
                              <div className="flex-shrink-0">
                                <span className="text-sm text-muted">
                                  1 hour ago
                                </span>
                              </div>
                            </div>
                            <p className="position-relative text-muted mt-1 mb-2">
                              <br />
                              <span className="text-truncate">
                                Lorem Ipsum has been the industry&apos;s
                                standard dummy text ever since the 1500s.
                              </span>
                            </p>
                          </div>
                        </div>
                      </li>
                      <li className="list-group-item">
                        <p className="text-span">Yesterday</p>
                        <div className="d-flex">
                          <div className="flex-shrink-0">
                            <div className="avtar avtar-s bg-light-danger">
                              <i className="ph-duotone ph-user f-18"></i>
                            </div>
                          </div>
                          <div className="flex-grow-1 ms-3">
                            <div className="d-flex">
                              <div className="flex-grow-1 me-3 position-relative">
                                <h6 className="mb-0 text-truncate">
                                  Challenge invitation
                                </h6>
                              </div>
                              <div className="flex-shrink-0">
                                <span className="text-sm text-muted">
                                  12 hour ago
                                </span>
                              </div>
                            </div>
                            <p className="position-relative text-muted mt-1 mb-2">
                              <br />
                              <span className="text-truncate">
                                <strong> Jonny aber</strong> invites to join the
                                challenge
                              </span>
                            </p>
                            <button className="btn btn-sm rounded-pill btn-outline-secondary me-2">
                              Decline
                            </button>
                            <button className="btn btn-sm rounded-pill btn-primary">
                              Accept
                            </button>
                          </div>
                        </div>
                      </li>
                      <li className="list-group-item">
                        <div className="d-flex">
                          <div className="flex-shrink-0">
                            <div className="avtar avtar-s bg-light-info">
                              <i className="ph-duotone ph-notebook f-18"></i>
                            </div>
                          </div>
                          <div className="flex-grow-1 ms-3">
                            <div className="d-flex">
                              <div className="flex-grow-1 me-3 position-relative">
                                <h6 className="mb-0 text-truncate">Forms</h6>
                              </div>
                              <div className="flex-shrink-0">
                                <span className="text-sm text-muted">
                                  2 hour ago
                                </span>
                              </div>
                            </div>
                            <p className="position-relative text-muted mt-1 mb-2">
                              Lorem Ipsum is simply dummy text of the printing
                              and typesetting industry. Lorem Ipsum has been the
                              industry&apos;s standard dummy text ever since the
                              1500s.
                            </p>
                          </div>
                        </div>
                      </li>
                      <li className="list-group-item">
                        <div className="d-flex">
                          <div className="flex-shrink-0">
                            <img
                              src={"/assets/images/user/avatar-2.jpg"}
                              alt="user-image"
                              className="user-avtar avtar avtar-s"
                            />
                          </div>
                          <div className="flex-grow-1 ms-3">
                            <div className="d-flex">
                              <div className="flex-grow-1 me-3 position-relative">
                                <h6 className="mb-0 text-truncate">
                                  Keefe Bond{" "}
                                  <span className="text-body">
                                    {" "}
                                    added new tags to{" "}
                                  </span>{" "}
                                  💪 Design system
                                </h6>
                              </div>
                              <div className="flex-shrink-0">
                                <span className="text-sm text-muted">
                                  2 min ago
                                </span>
                              </div>
                            </div>
                            <p className="position-relative text-muted mt-1 mb-2">
                              <br />
                              <span className="text-truncate">
                                Lorem Ipsum has been the industry&apos;s
                                standard dummy text ever since the 1500s.
                              </span>
                            </p>
                            <button className="btn btn-sm rounded-pill btn-outline-secondary me-2">
                              Decline
                            </button>
                            <button className="btn btn-sm rounded-pill btn-primary">
                              Accept
                            </button>
                          </div>
                        </div>
                      </li>
                      <li className="list-group-item">
                        <div className="d-flex">
                          <div className="flex-shrink-0">
                            <div className="avtar avtar-s bg-light-success">
                              <i className="ph-duotone ph-shield-checkered f-18"></i>
                            </div>
                          </div>
                          <div className="flex-grow-1 ms-3">
                            <div className="d-flex">
                              <div className="flex-grow-1 me-3 position-relative">
                                <h6 className="mb-0 text-truncate">Security</h6>
                              </div>
                              <div className="flex-shrink-0">
                                <span className="text-sm text-muted">
                                  5 hour ago
                                </span>
                              </div>
                            </div>
                            <p className="position-relative text-muted mt-1 mb-2">
                              Lorem Ipsum is simply dummy text of the printing
                              and typesetting industry. Lorem Ipsum has been the
                              industry&apos;s standard dummy text ever since the
                              1500s.
                            </p>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </SimpleBar>
                  <div className="dropdown-footer">
                    <div className="row g-3">
                      <div className="col-6">
                        <div className="d-grid">
                          <button className="btn btn-primary">
                            Archive all
                          </button>
                        </div>
                      </div>
                      <div className="col-6">
                        <div className="d-grid">
                          <button className="btn btn-outline-secondary">
                            Mark all as read
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </Dropdown.Menu>
              </Dropdown> */}
              <Dropdown as="li" className="pc-h-item header-user-profile">
                <Dropdown.Toggle
                  className="pc-head-link arrow-none me-0"
                  href="#"
                  aria-haspopup="false"
                  aria-expanded="false"
                  style={{ border: "none" }}
                >
                  <UserAvatar imageUrl={userData?.profileImageUrl} size={40} className="user-avtar" />
                </Dropdown.Toggle>
                <Dropdown.Menu className="dropdown-user-profile dropdown-menu-end pc-h-dropdown">
                  <div className="dropdown-header d-flex align-items-center justify-content-between">
                    <h4 className="m-0">Profile</h4>
                  </div>
                  <div className="dropdown-body">
                    <SimpleBar
                      className="profile-notification-scroll position-relative"
                      style={{ maxHeight: "calc(100vh - 225px)" }}
                    >
                      <ul className="list-group list-group-flush w-100">
                        <li className="list-group-item">
                          <div className="d-flex align-items-center">
                            <div className="flex-shrink-0">
                              <UserAvatar imageUrl={userData?.profileImageUrl} size={50} className="wid-50" />
                            </div>
                            <div className="flex-grow-1 mx-3">
                              <h5 className="mb-0">{userData?.firstName} {userData?.lastName}</h5>
                              <a
                                className="link-primary"
                                href={`mailto:${userData?.email}`}
                              >
                                {userData?.email}
                              </a>
                            </div>
                          </div>
                        </li>
                        {/* <li className="list-group-item"> */}
                        {/* <Dropdown.Item>
                            <span className="d-flex align-items-center">
                              <i className="ph-duotone ph-key"></i>
                              <span>{t("profile.changePassword")}</span>
                            </span>
                          </Dropdown.Item> */}
                        {/* <Dropdown.Item>
                            <span className="d-flex align-items-center">
                              <i className="ph-duotone ph-envelope-simple"></i>
                              <span>{t("profile.recentlyMail")}</span>
                            </span>
                            <div className="user-group">
                              <img
                                src={"/assets/images/user/avatar-1.jpg"}
                                alt="user-image"
                                className="avtar"
                              />
                              <img
                                src={"/assets/images/user/avatar-2.jpg"}
                                alt="user-image"
                                className="avtar"
                              />
                              <img
                                src={"/assets/images/user/avatar-3.jpg"}
                                alt="user-image"
                                className="avtar"
                              />
                            </div>
                          </Dropdown.Item> */}
                        {/* <Dropdown.Item>
                            <span className="d-flex align-items-center">
                              <i className="ph-duotone ph-calendar-blank"></i>
                              <span>{t("profile.scheduleMeetings")}</span>
                            </span>
                          </Dropdown.Item> */}
                        {/* </li> */}
                        {/* <li className="list-group-item"> */}
                        {/* <Dropdown.Item>
                            <span className="d-flex align-items-center">
                              <i className="ph-duotone ph-heart"></i>
                              <span>{t("profile.favorite")}</span>
                            </span>
                          </Dropdown.Item> */}
                        {/* <Dropdown.Item>
                            <span className="d-flex align-items-center">
                              <i className="ph-duotone ph-arrow-circle-down"></i>
                              <span>{t("profile.download")}</span>
                            </span>
                            <span className="avtar avtar-xs rounded-circle bg-danger text-white">
                              10
                            </span>
                          </Dropdown.Item> */}
                        {/* </li> */}
                        {/* <li className="list-group-item"> */}
                        {/* <div className="dropdown-item">
                            <span className="d-flex align-items-center">
                              <i className="ph-duotone ph-globe-hemisphere-west"></i>
                              <span>{t("profile.languages")}</span>
                            </span>
                            <span className="flex-shrink-0">
                              <select className="form-select bg-transparent form-select-sm border-0 shadow-none">
                                <option value="1">English</option>
                                <option value="2">Spain</option>
                                <option value="3">Arbic</option>
                              </select>
                            </span>
                          </div> */}
                        {/* <Dropdown.Item>
                            <span className="d-flex align-items-center">
                              <i className="ph-duotone ph-flag"></i>
                              <span>{t("profile.country")}</span>
                            </span>
                          </Dropdown.Item> */}
                        {/* <div className="dropdown-item">
                            <span className="d-flex align-items-center">
                              <i className="ph-duotone ph-moon"></i>
                              <span>{t("profile.darkMode")}</span>
                            </span>
                            <div className="form-check form-switch form-check-reverse m-0">
                              <input
                                className="form-check-input f-18"
                                id="dark-mode"
                                type="checkbox"
                                role="switch"
                              />
                            </div>
                          </div>
                        </li> */}
                        <li className="list-group-item">
                          <Dropdown.Item>
                            <span className="d-flex align-items-center">
                              <i className="ph-duotone ph-user-circle"></i>
                              <span>{t("profile.editProfile")}</span>
                            </span>
                          </Dropdown.Item>
                          {/* <Dropdown.Item>
                            <span className="d-flex align-items-center">
                              <i className="ph-duotone ph-star text-warning"></i>
                              <span>{t("profile.upgradeAccount")}</span>
                              <span className="badge bg-light-success border border-success ms-2">
                                {t("profile.new")}
                              </span>
                            </span>
                          </Dropdown.Item> */}
                          {/* <Dropdown.Item>
                            <span className="d-flex align-items-center">
                              <i className="ph-duotone ph-bell"></i>
                              <span>{t("profile.notifications")}</span>
                            </span>
                          </Dropdown.Item> */}
                          <Dropdown.Item>
                            <span className="d-flex align-items-center">
                              <i className="ph-duotone ph-gear-six"></i>
                              <span>{t("profile.settings")}</span>
                            </span>
                          </Dropdown.Item>
                        </li>
                        <li className="list-group-item">
                          {/* <Dropdown.Item>
                            <span className="d-flex align-items-center">
                              <i className="ph-duotone ph-plus-circle"></i>
                              <span>{t("profile.addAccount")}</span>
                            </span>
                          </Dropdown.Item> */}
                          <Dropdown.Item onClick={handleLogout}>
                            <span className="d-flex align-items-center">
                              <i className="ph-duotone ph-power"></i>
                              <span>{t("profile.logout")}</span>
                            </span>
                          </Dropdown.Item>
                        </li>
                      </ul>
                    </SimpleBar>
                  </div>
                </Dropdown.Menu>
              </Dropdown>
            </ul>
          </div>
        </div>
      </header >
    </>
  );
};

export default Header;
